/**
 * Neilsen homepage — product carousel controls.
 *
 * Progressive enhancement over a native scroll container:
 * the track scrolls and snaps without JS; this only wires up the
 * prev/next buttons and keeps their disabled state in sync.
 *
 * Re-initialises safely inside the Shopify theme editor via the
 * `shopify:section:load` event.
 */
(function () {
  'use strict';

  function initCarousel(root) {
    if (root.dataset.ntReady === 'true') return;

    var track = root.querySelector('[data-nt-track]');
    var prev = root.querySelector('[data-nt-prev]');
    var next = root.querySelector('[data-nt-next]');

    if (!track) return;

    function step() {
      var item = track.querySelector('.nt-product-slide');
      if (!item) return track.clientWidth * 0.8;

      var gap = parseFloat(window.getComputedStyle(track).columnGap) || 0;
      return item.getBoundingClientRect().width + gap;
    }

    function updateButtons() {
      var maxScroll = track.scrollWidth - track.clientWidth - 1;
      if (prev) prev.disabled = track.scrollLeft <= 0;
      if (next) next.disabled = track.scrollLeft >= maxScroll;
    }

    if (prev) {
      prev.addEventListener('click', function () {
        track.scrollBy({ left: -step(), behavior: 'smooth' });
      });
    }

    if (next) {
      next.addEventListener('click', function () {
        track.scrollBy({ left: step(), behavior: 'smooth' });
      });
    }

    track.addEventListener('scroll', updateButtons, { passive: true });
    window.addEventListener('resize', updateButtons, { passive: true });
    updateButtons();

    root.dataset.ntReady = 'true';
  }

  function init(scope) {
    (scope || document)
      .querySelectorAll('[data-nt-carousel]')
      .forEach(initCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
